<template>
  <div class="gallery-carusel-wrp">
    <div class="panorama-wrp">
      <iframe
        class="panorama-item"
        :src="baseUrl + items"
        height="100%"
        width="850px"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.vueAppBaseUrl;

const props = withDefaults(
  defineProps<{
    items: any;
  }>(),
  {
    items: null,
  },
);
</script>

<style lang="scss" scoped>
.gallery-carusel-wrp {
  .panorama-wrp {
    .panorama-item {
      height: 450px;
      border-radius: 8px;
      border: none;
      max-width: 100%;

      @media (max-width: $md) {
        height: 100%;
        min-height: 225px;
      }
    }
  }
}
</style>
